import React, { Component, Fragment } from 'react';
import { HashRouter,Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import {withTranslation} from "react-i18next";
import { currentWidget, setRegPage } from '../../../action/action'
import { setGoHome } from '../../action/homeAction'
import lisbon_hallway from './assets/lisbon_hallway.png';
import { DEMO } from '../../../config/constant';
import { setOpenDemoCamera } from '../../action/homeAction'
import { closeOrderPopUp } from '../../action/hCommerce2'
import $ from 'jquery';
import DemoRoomDoor from '../../../UI/doorKey/demoRoomDoor';

class RoomDoorCamera extends Component{

    constructor(props){
        super(props);
       
    }

    componentWillUnmount(){
        this.props.setGoHome(true);
        this.props.setOpenDemoCamera(false);
    }


    componentDidMount(){
        this.props.currentWidget({widgetType:true});
        $('#doorCamera').attr('style', 'padding-top: 5rem !important; height: 100%;');
    }


    render(){
        const { t } = this.props
        return(                

            <div class="main-container background-overlay">
                <header class="inner-pages subpages no-background" style={{
                    backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                }}>
                    <a onClick={DEMO ? () => {
                                        this.props.setGoHome(true);
                                        this.props.setOpenDemoCamera(false)
                                        } : () => this.props.setGoHome(true)} class="button-back"></a>
                    <div class="heading align-center">
                        <p class="bold" style={{textShadow:"none",color:"#fff"}}>{this.props.currentWidget.widgetTitle}</p>{/*{t('room_control.door_camera.heading')} */}
                    </div>
                </header>
                <section id="doorCamera" class="widgets padding-0 margin-0" >
                    <div class="camera-feed" style={{
                        height: "90vh", width: "100%", margin: '0',
                        background: `url('${lisbon_hallway}') center center no-repeat`,
                        backgroundSize: "cover"
                    }}>
                        
                    </div>
                    {/* <div style={{margin: '0 auto', marginTop:"10px"}}>
                        <button onClick={() => this.props.closeOrderPopUp(true, "Unlocking Door", null, null )} className="w-100" style={{
                            backgroundColor:"#fff",
                            color:this.props.menuColor.assetBackgroundSelectorColor
                        }}>Unlock door</button>
                    </div> */}

                    <div class="doorkey float-left">
                        <a href="javascript:void(0);" class="tile-container" onClick = {() => {
                            // this.props.setOpenDemoCamera(false);
                            this.props.closeOrderPopUp(true, t('room_control.door_camera.unlock_door_msg'), null, null )
                        }} style={{
                            backgroundColor:this.props.menuColor.assetBackgroundSelectorColor
                        }}>
                            <i class="fas fa-door-open"></i>
                        </a>
                    </div>
                    
                    <div class="doorkey">
                        <a onClick={DEMO ? () => {
                                            this.props.setGoHome(true);
                                            this.props.setOpenDemoCamera(false)
                                            } : () => this.props.setGoHome(true)} class="tile-container" style={{
                            backgroundColor:this.props.menuColor.assetBackgroundSelectorColor
                        }}>
                            <i class="fas fa-times"></i>
                        </a>
                    </div>
                </section>
            </div>
               
        );
    }
}

const mapStateToProps = (state) => {
    return {
        menuColor: state.store.home.MenuColor,
        currentWidget: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps,{
    currentWidget,
    setGoHome,
    setOpenDemoCamera,
    closeOrderPopUp
})(withTranslation('translations')(RoomDoorCamera));